import $ from "jquery";

const linksComponentObj = {
  variable:{
    url: window.location.href,
},
  methods: {

    handleDataLayer:(e)=>{
      $(e).find('.chli-linksComponent_btn').on('click', function(e){
        var obj = linksComponentObj.methods.linksObj(e);
        createDataLayer('buttonClick', obj);
    });
  },

    init: function () {
      $('.tender-notice').each((idx,ele)=>{
      linksComponentObj.methods.handleDataLayer(ele);
    });
    },

    linksObj : function(e) {
        var obj = {
            'articleName' : "",
            'blogCategory' : "",
            'blogPageCategory' : "",
            'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
            'pageSection' : e.currentTarget.closest('.tender-notice__linkmainbox').querySelector('.tender-notice__linkheading').innerText,
            'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? linksComponentObj.variable.url.includes("blog") ? "Blogs" : linksComponentObj.variable.url.substring(linksComponentObj.variable.url.indexOf(".com/"), linksComponentObj.variable.url.lastIndexOf('/')  === ".com") && !linksComponentObj.variable.url.substring(linksComponentObj.variable.url.indexOf(".com/"), linksComponentObj.variable.url.length-1).includes('/') ? "Home" : "Other Pages" : "Blog Details Page",
            'planOption' : "",
            'productCategory' : "",
            'productName' : "",
            'question' : "",
            'source' : "",
            'searchTerm' : "",
            'videoTitle' : "",
            'bannerName' : "",
        };
        return obj;
    }
  },
 };

 $(() => {
  if ($(".tender-notice").length > 0) {
 linksComponentObj.methods.init();
  }
});
